module.exports = __webpack_public_path__ + "img/support.52990743.jpg";